/* eslint-disable no-console */

import * as Sentry from '@sentry/vue'
import OpenAIApi from '@/api/openai'

const _state = {
}

const getters = {
}

const actions = {
  async createMultipleAnswersWordCloud(_, payload) {
    try {
      await OpenAIApi.createMultipleAnswersWordCloud(payload)
    } catch (error) {
      Sentry.captureException(`createMultipleAnswersWordCloud error: ${error}`)
    }
  },
}

const mutations = {
}

const openAI = {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}

export default openAI
